import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/index.scss';
import reportWebVitals from './reportWebVitals';

import './assets/fontAwesome';


//to get Geocoding, I need to set up search box, and make query about which location I need
//this converts to lat and lon, and then the state of the map changes accordingly

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>, 
    document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
